<template>
  <div class="blocked-page">
    <b-overlay
      :show="loading"
      :opacity="0"
      no-center
      variant="transparent"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>
      <div class="bl-card">
        <div
          class="bl-card-glow"
          aria-hidden="true"
        />
        <div class="bl-head">
          <span class="bl-icon">
            <feather-icon
              icon="SlashIcon"
              size="20"
            />
          </span>
          <div>
            <h3 class="bl-title">
              {{ $t('Blocked') }}
            </h3>
            <p>{{ $t("Blocked users can't message or call you.") }}</p>
          </div>
          <span
            v-if="users && users.length"
            class="bl-count"
          >{{ users.length }}</span>
        </div>

        <div
          v-if="!users || users.length < 1"
          class="bl-empty"
        >
          <span class="bl-empty-icon">
            <feather-icon
              icon="UserCheckIcon"
              size="30"
            />
          </span>
          <h4>{{ $t('You haven\'t blocked anyone yet') }}</h4>
        </div>

        <div
          v-else
          class="bl-grid"
        >
          <blocked-user-card
            v-for="user in users"
            :key="user.id"
            :user="user"
            @setLoading="setLoading($event)"
            @getUsers="getUsers"
          />
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import {showNotify, throwDefaultError} from '@/helpers/helpers'
import BlockedUserCard from '@/components/BlockedUserCard'

export default {
  name: 'interaction-blocked-users',
  props: {
    activeTabIndex: {
      type: Number,
      default: 1,
    },
  },
  components: {
    BOverlay,

    BlockedUserCard,
  },
  data() {
    return {
      loading: false,
      scrollOffsetForLoadMore: 100,
      users: [],
      usersLimit: 100,
      usersOffset: 0,
      usersAllLoaded: false,
    }
  },
  created() {
    this.getUsers()

    // Scroll'u dinle
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {

  },
  methods: {
    getUsers(clear = true) {
      this.loading = true
      useJwt.getBlockedUsers(this.usersOffset, this.usersLimit)
          .then(response => {
            if (clear) {
              this.users = response.data.body.users
            } else {
              this.users.push(...response.data.body.users)
            }

            // Offset ayarla
            this.usersOffset = response.data.body.offset + response.data.body.limit

            if (this.usersOffset >= response.data.body.totalCount) {
              this.usersAllLoaded = true
            }
          })
          .catch(error => {
            throwDefaultError(this.$toast, error)
          })
          .finally(() => { this.loading = false })
    },
    handleScroll (event) {
      if (this.activeTabIndex === 3) {
        if ((window.innerHeight + window.scrollY + this.scrollOffsetForLoadMore) >= document.body.scrollHeight &&
            !this.usersAllLoaded) {
          this.loadMore()
        }
      }
    },
    loadMore() {
      if (!this.loading) {
        this.getUsers(false)
      }
    },
    setLoading($event) {
      this.loading = $event
    },
  }
}
</script>

<style lang="scss">
/* Set the theme color of the component */
$themeColor: #F9447A;

/* import theme style */
@import '~vue-slider-component/lib/theme/default.scss';
</style>

<style lang="scss" scoped>
/* Sadece Ayarlar içinde: sayfa iç boşluğunu dengele */
#page-settings .blocked-page {
  margin: 0 -25px;
}

.bl-card {
  position: relative;
  overflow: hidden;
  background: rgba(32, 22, 72, 0.72);
  border: 1px solid rgba(150, 110, 255, 0.28);
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(6, 2, 24, 0.45);
  padding: 26px 30px 30px;
  min-height: 260px;

  @media (max-width: 575px) { padding: 20px 14px; }
}

.bl-card-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(234, 3, 178, 0.22), transparent 70%);
  pointer-events: none;
}

.bl-head {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(150, 110, 255, 0.2);

  p {
    color: rgba(226, 220, 255, 0.72);
    font-size: 13px;
    margin: 0;
  }
}

.bl-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #8b5cf6, #a855f7);
  flex-shrink: 0;
}

.bl-title {
  color: #fff !important;
  font-size: 20px !important;
  font-weight: 700;
  margin: 0 0 2px;
}

.bl-count {
  margin-left: auto;
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  background: linear-gradient(135deg, rgba(234, 3, 178, 0.28) 0%, rgba(168, 85, 247, 0.22) 50%, rgba(99, 102, 241, 0.12) 100%);
  border: 1px solid rgba(234, 3, 178, 0.35);
}

.bl-empty {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 30px 10px;
  text-align: center;

  h4 {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
}

.bl-empty-icon {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(170, 140, 255, 0.35);
}

.bl-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 991px) { grid-template-columns: 1fr; }

  /* BlockedUserCard bir b-col döndürüyor; ızgara içinde tam genişlik olsun */
  ::v-deep .blocked-user-card {
    flex: none;
    max-width: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  ::v-deep .blocked-user-card-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    margin: 0;
    border-radius: 14px;
    background: rgba(14, 10, 40, 0.45);
    border: 1px solid rgba(150, 110, 255, 0.2);
    box-shadow: none;
  }

  ::v-deep .blocked-user-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;

    .b-avatar {
      border: 2px solid rgba(234, 3, 178, 0.45);
    }
  }

  ::v-deep .blocked-user-link {
    color: #fff !important;
    font-weight: 600;
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  ::v-deep .blocked-user-right .btn {
    border: 1px solid rgba(170, 140, 255, 0.4) !important;
    background: rgba(139, 92, 246, 0.18) !important;
    color: #fff !important;
    border-radius: 9999px !important;
    padding: 7px 16px !important;
    font-weight: 600;
    white-space: nowrap;

    &:hover {
      background: linear-gradient(135deg, #8b5cf6, #a855f7) !important;
    }
  }
}
</style>
